export * from "./Live";
export * from "./PreLive";
export * from "./SportScoreboardComponents";
export * from "./contracts";
export const mocks = process.env.NODE_ENV !== "production" ? require("./mocks") : {};
//# sourceMappingURL=index.js.map